<template>
  <div>
    <base-header class="pb-6" type="">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 d-inline-block mb-0">{{language_terms['DASHBOARD']}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <b-breadcrumb class="breadcrumb-links">
              <b-breadcrumb-item><router-link to="/"><i class="fas fa-home"></i></router-link></b-breadcrumb-item>
              <b-breadcrumb-item><a href="#">{{language_terms['DASHBOARD']}}</a></b-breadcrumb-item>
              <!-- <b-breadcrumb-item active aria-current="page">{{language_terms['DASHBOARD']}}</b-breadcrumb-item> -->
            </b-breadcrumb>
          </nav>
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>
      <loading :active.sync="loading" 
          color= '#007bff'
          :width= '128'
          :height= '128'
          loader='dots'
          :can-cancel="true" 
          :is-full-page="true">
      </loading>
      <!-- Card stats -->
      <b-row v-if="0">
        <!-- {{dashboard_summary.cards}} -->
        <b-col xl="3" md="6" v-for="(card, index) in dashboard_summary.cards" :key="index">
          <b-card no-body :class="card.class">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">{{language_terms['APPROVAL_REQUESTS']}}</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{card.stats}}</span>
                  <base-progress class="progress-xs mt-3 mb-0" type="success" :value="30"></base-progress>
                </b-col>
              </b-row>
              <p class="mt-3 mb-0 text-sm">
                <a href="javascript:void(0)" class="text-nowrap text-white font-weight-600" @click="viewDetails(card.details_page_url)">{{language_terms['SEE_DETAILS']}}</a>
              </p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--6" v-if="1">       
        <b-row v-if="dashboard_summary.expired_reservations.length > 0">
          <b-col sm="12">
            <expiredReservations :title="'Expired Reservations (' + dashboard_summary.expired_reservations.length + ')'" :items="dashboard_summary.expired_reservations" :url="'/sales/sales-quotations'"/>
          </b-col>
        </b-row>

      <b-card-group deck class="flex-column flex-xl-row" v-if="0">
        <card>
          <b-row align-v="center" slot="header">
            <b-col>
              <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
              <h5 class="h3 mb-0">Sales value</h5>
            </b-col>
          </b-row>
          <line-chart
            :height="350"
            ref="bigChart"
            :chart-data="bigLineChart.chartData"
            :extra-options="bigLineChart.extraOptions"
          >
          </line-chart>

        </card>

        <card header-classes="bg-transparent">
          <b-row align-v="center" slot="header">
            <b-col>
              <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
              <h5 class="h3 mb-0">Total orders</h5>
            </b-col>
          </b-row>

          <bar-chart
            :height="350"
            ref="barChart"
            :chart-data="redBarChart.chartData"
          >
          </bar-chart>
        </card>
        <!-- Progress track list-->

      </b-card-group>
      <!-- End charts-->

      <!--Tables & Widgets-->
      <!-- <b-row>
        <b-col xl="8">
          <light-table :item-limit="5"></light-table>
        </b-col>
        <b-col xl="4">
          <vector-map-card></vector-map-card>
        </b-col>
      </b-row> -->
      <!--End Tables & Widgets-->

      <!--Lists-->
      <b-card-group deck class="flex-column flex-xl-row">
        <!-- Members list group card -->
        <!-- <members-card :show-search="false"></members-card> -->
        <!-- Checklist -->
        <!-- <task-list></task-list> -->
        <!-- Progress track -->
        <!--<card>-->
          <!-- Card header -->
          <!-- <h5 slot="header" class="h3 mb-0">Progress track</h5> -->
          <!-- Card body -->
          <!-- <progress-track-list :item-limit="5"></progress-track-list> -->
        <!--</card>-->
      </b-card-group>
      <!--End lists-->


    </b-container>


  </div>
</template>
<script>
  import { mapState } from "vuex";

  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // Components
  import BaseHeader from '@/components/BaseHeader';
  import BaseProgress from '@/components/BaseProgress';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';

  // Lists
  import ProgressTrackList from './ProgressTrackList';
  import MembersCard from '@/views/Widgets/MembersCard';
  import TaskList from '@/views/Widgets/TaskList';

  // Tables
  import quotations from './quotations';
  import expiredReservations from './expiredReservations';
  import VectorMapCard from '@/views/Widgets/VectorMapCard'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ExpiredReservations from "./expiredReservations.vue";

  export default {
    computed: {
      ...mapState({
          language_terms: (state) => state.languages.language_terms,
          selected_lang: (state) => state.languages.selected_langauge,
          dashboard_summary: (state) => state.auth.dashboard_summary
        }),
    },
    components: {
      Loading,
      LineChart,
      BarChart,
      BaseHeader,
      BaseProgress,
      RouteBreadCrumb,
      StatsCard,
      TaskList,
      VectorMapCard,
      quotations,
      expiredReservations,
      ProgressTrackList,
      MembersCard
    },
    async mounted()
    {
      this.loading = true
      await this.fetchDashboardSummary()
      this.loading = false
    },
    data() {
      return {
        loading:false,
        bigLineChart: {
          chartData: {
            datasets: [
              {
                label: 'Performance',
                data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
              }
            ],
            labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },
        redBarChart: {
          chartData: {
            labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
              label: 'Sales',
              data: [25, 20, 30, 22, 17, 29]
            }]
          }
        }
      };
    },
    methods:
    {
      async fetchDashboardSummary()
      {
        await this.$store.dispatch("auth/fetchDashboardSummary", {})
      },
      viewDetails(url)
      {
        this.loading = true
        this.$router.push(url)
        this.loading = false
      }
    }
  };
</script>
<style></style>
